// Bilingual translations PT (default) and FR for BID Soluções Integradas
export const translations = {
  pt: {
    nav: {
      about: "Sobre",
      services: "Serviços",
      portfolio: "Cases",
      commerce: "EPIs",
      contact: "Contato",
      cta: "Consultoria Técnica",
    },
    hero: {
      overline: "Engenharia · Segurança · Indústria",
      title: "Soluções Integradas em Engenharia e Segurança do Trabalho",
      subtitle:
        "Especialistas em NR12, NR33 e NR35. Projetos customizados, inovação tecnológica e redução de custos operacionais para grandes indústrias.",
      cta: "Agendar Consultoria Técnica",
      ctaSecondary: "Conheça nossos serviços",
      slogan: "Uma empresa a serviço da vida.",
      stats: [
        { value: "+20", label: "Anos de Experiência Técnica" },
        { value: "+150", label: "Projetos Industriais Entregues" },
        { value: "5", label: "Áreas de Engenharia" },
        { value: "100%", label: "Conformidade com NR's" },
      ],
    },
    about: {
      overline: "Sobre a BID",
      title: "Autoridade técnica para a indústria de alto risco",
      lead:
        "A BID Soluções Integradas atua há anos ao lado de grandes operações de Mineração e Indústria Pesada, entregando projetos de engenharia e segurança que protegem pessoas, ativos e o meio ambiente.",
      paragraphs: [
        "Nosso corpo técnico é formado por Engenheiros Mecânicos, Civis, Elétricos, Químicos e Ambientais com vivência prática em campo, capazes de traduzir normas regulamentadoras em soluções aplicáveis ao chão de fábrica.",
        "Atuamos do diagnóstico ao comissionamento — passando por projeto, fabricação, instalação e manutenção — sempre com foco em redução de custos operacionais, conformidade legal e zero acidente.",
      ],
      mission: {
        title: "Nossa Missão",
        text: "Desenvolver produtos e serviços especializados para a proteção e a saúde do trabalhador.",
      },
      pillars: [
        { title: "Multidisciplinar", text: "5 engenharias atuando integradas em cada projeto." },
        { title: "Experiência de Campo", text: "Décadas em mineração e indústria pesada." },
        { title: "Inovação Tecnológica", text: "Automação, IoT e proteção inteligente de máquinas." },
        { title: "Conformidade Total", text: "NR12, NR33, NR35 e demais normas brasileiras." },
      ],
    },
    services: {
      overline: "Soluções Técnicas",
      title: "Três frentes para uma operação industrial segura e produtiva",
      subtitle:
        "Cada serviço é projetado por engenheiros e executado por equipes certificadas, com rastreabilidade completa.",
      items: [
        {
          tag: "NR10",
          title: "Consultoria & Meio Ambiente",
          desc:
            "Gestão de instalações elétricas, consultoria técnica e soluções ambientais sustentáveis para grandes operações.",
          bullets: [
            "Segurança em instalações elétricas",
            "Consultoria técnica especializada",
            "Licenciamento ambiental",
            "Soluções de efluentes e resíduos",
          ],
        },
        {
          tag: "NR33",
          title: "Segurança em Altura",
          desc:
            "Projetos, instalação e manutenção em caldeiras, tanques, vasos de pressão e estruturas metálicas.",
          bullets: [
            "Linhas de vida e pontos de ancoragem",
            "Inspeção de caldeiras e vasos de pressão",
            "Estruturas metálicas e plataformas",
            "Treinamento de equipes",
          ],
        },
        {
          tag: "NR35",
          title: "Segurança de Máquinas",
          desc:
            "Proteção de partes móveis, automação e eletrônica para adequação completa de máquinas e equipamentos.",
          bullets: [
            "Apreciação de risco e laudo NR35",
            "Proteções fixas e móveis intertravadas",
            "CLP, relés de segurança e sensores",
            "Retrofit eletroeletrônico",
          ],
        },
      ],
    },
    showcase: {
      overline: "NR12 em Ação",
      title: "Proteção de Partes Móveis",
      subtitle: "Soluções em Automação e Eletrônica",
      description:
        "Galeria de aplicações reais executadas pela BID: gaiolas e grades de proteção, esteiras transportadoras, células robotizadas, sensores de segurança e enclausuramentos industriais — todos em conformidade com a NR12.",
      tags: [
        "Gaiolas de Proteção",
        "Esteiras Transportadoras",
        "Células Robotizadas",
        "Sensores de Segurança",
        "Enclausuramentos",
        "Cortinas de Luz",
        "Retrofit Eletrônico",
        "Painéis de Comando",
      ],
      galleryCaptions: [
        "Gaiolas de Proteção",
        "Esteiras Transportadoras",
        "Células Robotizadas",
        "Automação & Eletrônica",
        "Transportadores Industriais",
        "Proteções Intertravadas",
      ],
    },
    extraServices: {
      overline: "Serviços Adicionais",
      title: "Mais soluções terceirizadas para a sua operação",
      subtitle:
        "Além da engenharia e segurança, a BID oferece serviços terceirizados com profissionais selecionados, treinados e em constante qualificação.",
      items: [
        {
          title: "Portaria Terceirizada & Controle de Acesso",
          image: "/agenteportaria.jpg", // Adicione o caminho da sua imagem aqui, ex: "/images/portaria.jpg"
          desc:
            "Profissionais treinados, cordiais e simpáticos para controle de entrada de pessoas e veículos, identificação, autorização de acesso e fiscalização de perímetros — com tecnologia de ponta e atendimento humanizado.",
          features: [
            "Controle de visitantes e prestadores",
            "Fiscalização de perímetros",
            "Tecnologia de identificação",
            "Atendimento humanizado",
          ],
        },
        {
          title: "Cozinheiras & Alimentação Industrial",
          image: "/cozinheira.jpg", // Adicione o caminho da sua imagem aqui
          desc:
            "Selecionamos as melhores cozinheiras para preparar refeições com alto nível de higiene, seguindo rigorosamente cardápios pré-definidos ou dietas específicas conforme a necessidade do cliente.",
          features: [
            "Alto padrão de higiene",
            "Cardápios pré-definidos",
            "Dietas específicas",
            "Equipe selecionada",
          ],
        },
        {
          title: "Auxiliar de Serviços Gerais (ASG)",
          image: "/servicosgeral.jpg", // Adicione o caminho da sua imagem aqui
          desc:
            "Suporte imediato em diversas funções da empresa: esclarecimento de dúvidas, carga e descarga de mercadorias, pequenos serviços de manutenção e limpeza — garantindo o suporte necessário para sua operação.",
          features: [
            "Carga e descarga",
            "Limpeza industrial",
            "Pequenos reparos",
            "Apoio operacional",
          ],
        },
        {
          title: "Auxiliar de Produção",
          image: "/auxiliardeproducao.jpg", // Adicione o caminho da sua imagem aqui
          desc:
            "Profissionais qualificados para apoio direto à linha de produção: operação assistida, alimentação de máquinas, embalagem, controle de qualidade visual e movimentação interna de materiais.",
          features: [
            "Alimentação de máquinas",
            "Embalagem industrial",
            "Controle visual de qualidade",
            "Movimentação interna",
          ],
        },
      ],
    },
    commerce: {
      overline: "Divisão Comercial BID",
      title: "Mais que serviços: produtos e logística internacional",
      subtitle:
        "A BID atua também no fornecimento de EPIs certificados e em operações de importação e exportação, aproveitando a posição estratégica de Oiapoque (AP) na fronteira com a Guiana Francesa.",
      items: [
        {
          tag: "EPIs",
          title: "Vendas de EPIs",
          desc:
            "Equipamentos de Proteção Individual certificados (CA) para indústria, mineração e construção. Confira nossa proposta mais recente:",
          isQuote: true,
          quoteHeader: "Att. Compras – Elvis Dourado | Porto Trombetas, 19 de Maio de 2026",
          imagePlaceholder: "/epis.jpg",
          location: "Porto Trombetas",
          conditions: [
            "Pagamento: 100% do boleto após recebimento do material",
            "Impostos inclusos",
            "Validade da proposta: 10 dias",
            "Entrega em Porto Trombetas: envio aéreo via Santarém, 7 a 12 dias",
          ],
          contactName: "Elvis Dourado",
          contactPhone: "(93) 99176-3730",
          cta: "Solicitar cotação",
        },
      ],
      uniforms: {
        tag: "Uniformes",
        title: "Uniformes Personalizados",
        subtitle: "Qualidade, segurança e identidade para cada setor.",
        imagePlaceholder: "/uniformes.jpg", // Adicione o caminho da sua imagem aqui
        characteristics: [
          {
            title: "Tecido de Alta Qualidade",
            desc: "Conforto, durabilidade e resistência para o dia a dia."
          },
          {
            title: "Personalização Total",
            desc: "Bordado ou silk com sua marca, reforçando a identidade da sua empresa."
          },
          {
            title: "Segurança e Conformidade",
            desc: "Atende às normas do seu segmento, garantindo proteção e segurança."
          },
          {
            title: "Equipe Padronizada",
            desc: "Mais profissionalismo, organização e credibilidade para seu negócio."
          }
        ],
        segments: [
          "Mineradoras",
          "Indústria de Óleo e Gás",
          "Indústrias",
          "Construção Civil",
          "Logística e Transporte",
          "Serviços e Manutenção"
        ],
        features: [
          { title: "Resistência", desc: "Materiais de alta durabilidade." },
          { title: "Conforto", desc: "Tecidos leves e respiráveis." },
          { title: "Acabamento Premium", desc: "Costuras reforçadas e acabamento de alto padrão." },
          { title: "Cores e Modelos", desc: "Diversas opções de cores e modelos." },
          { title: "Sua Marca em Destaque", desc: "Fortaleça sua marca com uniformes personalizados." }
        ],
        cta: "Solicitar orçamento de uniformes"
      },
    },
    importExport: {
      overline: "Comércio Exterior",
      title: "Importação & Exportação",
      description: "Operações de comércio exterior pela fronteira Oiapoque–Guiana Francesa: desembaraço aduaneiro, logística transfronteiriça e simplificação de procedimentos.",
      features: [
        "Comércio transfronteiriço Brasil–Guiana Francesa",
        "Eliminação de burocracias ineficientes",
        "Redução de tempos e custos para o cliente",
        "Tecnologia de ponta em procedimentos",
        "Apoio em documentação e licenciamento",
        "Sede estratégica em Oiapoque (AP)",
      ],
      cta: "Falar com Comex",
    },

    portfolio: {
      overline: "Cases de Sucesso",
      title: "Projetos que sustentam a operação industrial",
      subtitle: "Manutenção, jateamento, pintura e tubulações executados com engenharia BID.",
      items: [
        {
          title: "Manutenção Industrial Pesada",
          desc:
            "Programas preventivos e corretivos em plantas de mineração com cronogramas integrados de paradas.",
          tag: "Manutenção",
        },
        {
          title: "Jateamento & Tratamento de Superfície",
          desc:
            "Preparação de superfícies metálicas conforme padrões SSPC para máxima aderência de revestimentos.",
          tag: "Jateamento",
        },
        {
          title: "Pintura Industrial Anticorrosiva",
          desc:
            "Sistemas de pintura epóxi e poliuretano em estruturas, tanques e tubulações de grande porte.",
          tag: "Pintura",
        },
        {
          title: "Montagem & Tubulações",
          desc:
            "Engenharia, fabricação e montagem de tubulações industriais com testes de estanqueidade e END.",
          tag: "Tubulações",
        },
      ],
    },
    form: {
      title: "Agendar Consultoria Técnica",
      subtitle:
        "Preencha os dados abaixo. Nosso time de engenharia retorna em até 1 dia útil.",
      name: "Nome completo",
      company: "Empresa",
      role: "Cargo / Função",
      email: "E-mail corporativo",
      phone: "Telefone / WhatsApp",
      message: "Descreva seu desafio operacional",
      submit: "Enviar solicitação",
      whatsapp: "Falar agora no WhatsApp",
      success: "Solicitação enviada! Nossa equipe entrará em contato em breve.",
      error: "Não foi possível enviar. Tente novamente ou use o WhatsApp.",
    },
    footer: {
      slogan: "Uma empresa a serviço da vida.",
      description:
        "Engenharia integrada para mineração, indústria pesada e operações críticas em todo o Brasil.",
      sections: {
        company: "Empresa",
        services: "Serviços",
        contact: "Contato",
      },
      seal: "Selo de Qualidade e Profissionalismo",
      rights: "Todos os direitos reservados.",
    },
    common: {
      learnMore: "Saiba mais",
      close: "Fechar",
    },
  },
  fr: {
    nav: {
      about: "À propos",
      services: "Services",
      portfolio: "Réalisations",
      commerce: "EPI",
      contact: "Contact",
      cta: "Consultation Technique",
    },
    hero: {
      overline: "Ingénierie · Sécurité · Industrie",
      title: "Solutions Intégrées en Ingénierie et Sécurité du Travail",
      subtitle:
        "Spécialistes des normes NR12, NR35 et NR33. Projets sur mesure, innovation technologique et réduction des coûts opérationnels pour la grande industrie.",
      cta: "Planifier une consultation",
      ctaSecondary: "Découvrir nos services",
      slogan: "Une entreprise au service de la vie.",
      stats: [
        { value: "+20", label: "Années d'expérience technique" },
        { value: "+150", label: "Projets industriels livrés" },
        { value: "5", label: "Domaines d'ingénierie" },
        { value: "100%", label: "Conformité réglementaire" },
      ],
    },
    about: {
      overline: "À propos de BID",
      title: "Autorité technique pour l'industrie à haut risque",
      lead:
        "BID Soluções Integradas accompagne depuis des années les grandes opérations minières et industrielles, en livrant des projets d'ingénierie et de sécurité qui protègent les personnes, les actifs et l'environnement.",
      paragraphs: [
        "Notre équipe technique réunit des ingénieurs Mécaniques, Civils, Électriques, Chimiques et Environnementaux, expérimentés sur le terrain, capables de traduire les normes en solutions opérationnelles.",
        "Nous intervenons du diagnostic à la mise en service — étude, fabrication, installation et maintenance — toujours avec un objectif clair : réduction des coûts, conformité légale et zéro accident.",
      ],
      mission: {
        title: "Notre Mission",
        text: "Développer des produits et services spécialisés pour la protection et la santé du travailleur.",
      },
      pillars: [
        { title: "Multidisciplinaire", text: "5 spécialités d'ingénierie intégrées." },
        { title: "Expérience terrain", text: "Décennies en mines et industrie lourde." },
        { title: "Innovation Technologique", text: "Automatisation, IoT et protection intelligente." },
        { title: "Conformité totale", text: "NR12, NR33, NR35 et normes brésiliennes." },
      ],
    },
    services: {
      overline: "Solutions Techniques",
      title: "Trois axes pour une opération industrielle sûre et productive",
      subtitle:
        "Chaque service est conçu par des ingénieurs et exécuté par des équipes certifiées, avec une traçabilité complète.",
      items: [
        {
          tag: "NR10",
          title: "Conseil & Environnement",
          desc:
            "Gestion des installations électriques, conseil technique et solutions environnementales durables pour les grandes opérations.",
          bullets: [
            "Sécurité des installations électriques",
            "Conseil technique spécialisé",
            "Études et autorisations environnementales",
            "Effluents et déchets industriels",
          ],
        },
        {
          tag: "NR33",
          title: "Travail en Hauteur",
          desc:
            "Projets, installation et maintenance sur chaudières, réservoirs, appareils sous pression et structures métalliques.",
          bullets: [
            "Lignes de vie et points d'ancrage",
            "Inspection de chaudières et appareils sous pression",
            "Structures métalliques et plateformes",
            "Formation des équipes",
          ],
        },
        {
          tag: "NR35",
          title: "Sécurité des Machines",
          desc:
            "Protection des pièces mobiles, automatisation et électronique pour la mise en conformité complète des équipements.",
          bullets: [
            "Analyse de risque et rapport NR35",
            "Protections fixes et mobiles inter-verrouillées",
            "Automates, relais de sécurité et capteurs",
            "Rétrofit électro-électronique",
          ],
        },
      ],
    },
    showcase: {
      overline: "NR12 en Action",
      title: "Protection des Parties Mobiles",
      subtitle: "Solutions en Automatisation et Électronique",
      description:
        "Galerie d'applications réelles réalisées par BID : cages et grilles de protection, convoyeurs, cellules robotisées, capteurs de sécurité et enceintes industrielles — toutes conformes à la norme NR12.",
      tags: [
        "Cages de protection",
        "Convoyeurs",
        "Cellules robotisées",
        "Capteurs de sécurité",
        "Enceintes",
        "Barrières immatérielles",
        "Rétrofit électronique",
        "Armoires de commande",
      ],
      galleryCaptions: [
        "Cages de protection",
        "Convoyeurs",
        "Cellules robotisées",
        "Automatisation & Électronique",
        "Transporteurs Industriels",
        "Protections inter-verrouillées",
      ],
    },
    extraServices: {
      overline: "Services Additionnels",
      title: "Plus de solutions externalisées pour votre opération",
      subtitle:
        "Au-delà de l'ingénierie et de la sécurité, BID propose des services externalisés avec des professionnels sélectionnés, formés et qualifiés en continu.",
      items: [
        {
          title: "Gardiennage & Contrôle d'accès",
          image: "/agenteportaria.jpg",
          desc:
            "Professionnels formés, cordiaux et accueillants pour le contrôle d'entrée des personnes et véhicules, l'identification, l'autorisation d'accès et la surveillance des périmètres — avec une technologie de pointe.",
          features: [
            "Contrôle des visiteurs et prestataires",
            "Surveillance des périmètres",
            "Technologie d'identification",
            "Accueil humanisé",
          ],
        },
        {
          title: "Cuisinières & Restauration industrielle",
          image: "/cozinheira.jpg",
          desc:
            "Nous sélectionnons les meilleures cuisinières pour préparer des repas avec un haut niveau d'hygiène, en suivant rigoureusement les menus prédéfinis ou les régimes spécifiques.",
          features: [
            "Haut standard d'hygiène",
            "Menus prédéfinis",
            "Régimes spécifiques",
            "Équipe sélectionnée",
          ],
        },
        {
          title: "Agents de Services Généraux (ASG)",
          image: "/servicosgeral.jpg",
          desc:
            "Support immédiat dans diverses fonctions de l'entreprise : information, chargement/déchargement, petits travaux d'entretien et nettoyage — garantissant le soutien opérationnel nécessaire.",
          features: [
            "Chargement / déchargement",
            "Nettoyage industriel",
            "Petites réparations",
            "Support opérationnel",
          ],
        },
        {
          title: "Auxiliaire de Production",
          image: "/auxiliardeproducao.jpg",
          desc:
            "Professionnels qualifiés pour soutenir directement la ligne de production : opération assistée, alimentation des machines, emballage, contrôle qualité visuel et manutention interne.",
          features: [
            "Alimentation des machines",
            "Emballage industriel",
            "Contrôle qualité visuel",
            "Manutention interne",
          ],
        },
      ],
    },
    commerce: {
      overline: "Division Commerciale BID",
      title: "Plus que des services : produits et logistique internationale",
      subtitle:
        "BID assure également la fourniture d'EPI certifiés et les opérations d'import/export, profitant de la position stratégique d'Oiapoque (AP) à la frontière avec la Guyane française.",
      items: [
        {
          tag: "EPI",
          title: "Vente d'EPI",
          desc:
            "Équipements de Protection Individuelle certifiés pour l'industrie, les mines et la construction. Découvrez notre dernière proposition :",
          isQuote: true,
          quoteHeader: "Att. Achats – Elvis Dourado | Porto Trombetas, 19 Mai 2026",
          imagePlaceholder: "/epis.jpg",
          location: "Porto Trombetas",
          conditions: [
            "Paiement : 100% à réception du matériel",
            "Taxes incluses",
            "Validité de la proposition : 10 jours",
            "Livraison à Porto Trombetas : envoi aérien via Santarém, 7 à 12 jours",
          ],
          contactName: "Elvis Dourado",
          contactPhone: "(93) 99176-3730",
          cta: "Demander un devis",
        },
      ],
      uniforms: {
        tag: "Uniformes",
        title: "Uniformes Personnalisés",
        subtitle: "Qualité, sécurité et identité pour chaque secteur.",
        imagePlaceholder: "/uniformes.jpg",
        characteristics: [
          {
            title: "Tissu de Haute Qualité",
            desc: "Confort, durabilité et résistance pour le quotidien."
          },
          {
            title: "Personnalisation Totale",
            desc: "Broderie ou sérigraphie avec votre marque, renforçant l'identité de votre entreprise."
          },
          {
            title: "Sécurité et Conformité",
            desc: "Répond aux normes de votre secteur, garantissant protection et sécurité."
          },
          {
            title: "Équipe Standardisée",
            desc: "Plus de professionnalisme, d'organisation et de crédibilité pour votre entreprise."
          }
        ],
        segments: [
          "Mines",
          "Industrie Pétrolière et Gazière",
          "Industries",
          "Construction Civile",
          "Logistique et Transport",
          "Services et Maintenance"
        ],
        features: [
          { title: "Résistance", desc: "Matériaux de haute durabilité." },
          { title: "Confort", desc: "Tissus légers et respirants." },
          { title: "Finition Premium", desc: "Coutures renforcées et finition haut de gamme." },
          { title: "Couleurs et Modèles", desc: "Diverses options de couleurs et modèles." },
          { title: "Votre Marque en Vedette", desc: "Renforcez votre marque avec des uniformes personnalisés." }
        ],
        cta: "Demander un devis pour les uniformes"
      },
    },
    importExport: {
      overline: "Commerce Extérieur",
      title: "Import & Export",
      description: "Opérations de commerce extérieur via la frontière Oiapoque–Guyane française : dédouanement, logistique transfrontalière et simplification des procédures.",
      features: [
        "Commerce transfrontalier Brésil–Guyane française",
        "Élimination des bureaucraties inefficaces",
        "Réduction des délais et coûts pour le client",
        "Technologie de pointe en procédures",
        "Soutien en documentation et licences",
        "Siège stratégique à Oiapoque (AP)",
      ],
      cta: "Parler avec Comex",
    },

    portfolio: {
      overline: "Études de cas",
      title: "Des projets qui soutiennent l'opération industrielle",
      subtitle: "Maintenance, sablage, peinture et tuyauteries livrés avec l'ingénierie BID.",
      items: [
        {
          title: "Maintenance industrielle lourde",
          desc:
            "Programmes préventifs et correctifs sur sites miniers avec arrêts planifiés intégrés.",
          tag: "Maintenance",
        },
        {
          title: "Sablage & Traitement de surface",
          desc:
            "Préparation des surfaces métalliques selon les standards SSPC pour une adhérence maximale.",
          tag: "Sablage",
        },
        {
          title: "Peinture industrielle anticorrosion",
          desc:
            "Systèmes époxy et polyuréthane sur structures, réservoirs et tuyauteries de grand format.",
          tag: "Peinture",
        },
        {
          title: "Montage & Tuyauteries",
          desc:
            "Ingénierie, fabrication et montage de tuyauteries avec essais d'étanchéité et CND.",
          tag: "Tuyauteries",
        },
      ],
    },
    form: {
      title: "Planifier une consultation technique",
      subtitle:
        "Remplissez le formulaire ci-dessous. Notre équipe d'ingénierie vous répond sous 1 jour ouvré.",
      name: "Nom complet",
      company: "Entreprise",
      role: "Poste / Fonction",
      email: "E-mail professionnel",
      phone: "Téléphone / WhatsApp",
      message: "Décrivez votre défi opérationnel",
      submit: "Envoyer la demande",
      whatsapp: "Parler maintenant sur WhatsApp",
      success: "Demande envoyée ! Notre équipe vous contactera bientôt.",
      error: "Impossible d'envoyer. Réessayez ou utilisez WhatsApp.",
    },
    footer: {
      slogan: "Une entreprise au service de la vie.",
      description:
        "Ingénierie intégrée pour les mines, l'industrie lourde et les opérations critiques au Brésil.",
      sections: {
        company: "Entreprise",
        services: "Services",
        contact: "Contact",
      },
      seal: "Sceau de Qualité et Professionnalisme",
      rights: "Tous droits réservés.",
    },
    common: {
      learnMore: "En savoir plus",
      close: "Fermer",
    },
  },
  en: {
    nav: {
      about: "About",
      services: "Services",
      portfolio: "Cases",
      commerce: "PPE",
      contact: "Contact",
      cta: "Technical Consulting",
    },
    hero: {
      overline: "Engineering · Safety · Industry",
      title: "Integrated Engineering and Occupational Safety Solutions",
      subtitle:
        "Specialists in NR12, NR35 and NR33. Custom projects, technological innovation and operational cost reduction for large industries.",
      cta: "Book Technical Consulting",
      ctaSecondary: "Explore our services",
      slogan: "A company at the service of life.",
      stats: [
        { value: "+20", label: "Years of Technical Experience" },
        { value: "+150", label: "Industrial Projects Delivered" },
        { value: "5", label: "Engineering Disciplines" },
        { value: "100%", label: "NR Compliance" },
      ],
    },
    about: {
      overline: "About BID",
      title: "Technical authority for high-risk industry",
      lead:
        "BID Soluções Integradas has supported large-scale mining and heavy industry operations for years, delivering engineering and safety projects that protect people, assets and the environment.",
      paragraphs: [
        "Our technical team combines Mechanical, Civil, Electrical, Chemical and Environmental engineers with hands-on field experience, capable of translating regulatory standards into shop-floor solutions.",
        "We operate from diagnosis to commissioning — design, manufacturing, installation and maintenance — always focused on operational cost reduction, legal compliance and zero accidents.",
      ],
      mission: {
        title: "Our Mission",
        text: "To develop specialized products and services for worker protection and health.",
      },
      pillars: [
        { title: "Multidisciplinary", text: "5 engineering disciplines working together on every project." },
        { title: "Field Experience", text: "Decades in mining and heavy industry." },
        { title: "Technological Innovation", text: "Automation, IoT and smart machine protection." },
        { title: "Full Compliance", text: "NR12, NR33, NR35 and all Brazilian standards." },
      ],
    },
    services: {
      overline: "Technical Solutions",
      title: "Three pillars for a safe and productive industrial operation",
      subtitle:
        "Every service is designed by engineers and executed by certified teams, with full traceability.",
      items: [
        {
          tag: "NR10",
          title: "Consulting & Environment",
          desc:
            "Electrical installation management, technical consulting, and sustainable environmental solutions for large operations.",
          bullets: [
            "Electrical installation safety",
            "Specialized technical consulting",
            "Environmental licensing",
            "Effluent and waste solutions",
          ],
        },
        {
          tag: "NR33",
          title: "Working at Heights",
          desc:
            "Design, installation and maintenance of boilers, tanks, pressure vessels and steel structures.",
          bullets: [
            "Lifelines and anchor points",
            "Boiler and pressure vessel inspection",
            "Steel structures and platforms",
            "Team certification training",
          ],
        },
      ],
    },
    showcase: {
      overline: "NR12 in Action",
      title: "Moving Parts Protection",
      subtitle: "Automation and Electronics Solutions",
      description:
        "Gallery of real applications executed by BID: protection cages and guards, conveyors, robotic cells, safety sensors and industrial enclosures — all NR12 compliant.",
      tags: [
        "Protection Cages",
        "Conveyors",
        "Robotic Cells",
        "Safety Sensors",
        "Enclosures",
        "Light Curtains",
        "Electronic Retrofit",
        "Control Panels",
      ],
      galleryCaptions: [
        "Protection Cages",
        "Conveyors",
        "Robotic Cells",
        "Automation & Electronics",
        "Industrial Conveyors",
        "Interlocked Guards",
      ],
    },
    extraServices: {
      overline: "Additional Services",
      title: "More outsourced solutions for your operation",
      subtitle:
        "Beyond engineering and safety, BID offers outsourced services with selected, trained professionals in continuous qualification.",
      items: [
        {
          title: "Outsourced Security & Access Control",
          image: "/agenteportaria.jpg",
          desc:
            "Trained, courteous professionals for personnel and vehicle access control, identification, authorization and perimeter monitoring — with cutting-edge technology.",
          features: [
            "Visitor and contractor control",
            "Perimeter monitoring",
            "Identification technology",
            "Humanized service",
          ],
        },
        {
          title: "Cooks & Industrial Catering",
          image: "/cozinheira.jpg",
          desc:
            "We select the best cooks to prepare meals with high hygiene standards, strictly following predefined menus or specific diets according to client needs.",
          features: [
            "High hygiene standard",
            "Predefined menus",
            "Specific diets",
            "Selected team",
          ],
        },
        {
          title: "General Services Assistant (ASG)",
          image: "/servicosgeral.jpg",
          desc:
            "Immediate support across various company functions: information, loading/unloading, minor maintenance and cleaning — ensuring the operational support required.",
          features: [
            "Loading / unloading",
            "Industrial cleaning",
            "Minor repairs",
            "Operational support",
          ],
        },
        {
          title: "Production Assistant",
          image: "/auxiliardeproducao.jpg",
          desc:
            "Qualified professionals for direct production line support: assisted operation, machine feeding, packaging, visual quality control and internal material handling.",
          features: [
            "Machine feeding",
            "Industrial packaging",
            "Visual quality control",
            "Internal handling",
          ],
        },
      ],
    },
    commerce: {
      overline: "BID Commercial Division",
      title: "More than services: products and international logistics",
      subtitle:
        "BID also supplies certified PPE and runs import/export operations, leveraging the strategic position of Oiapoque (AP) at the French Guiana border.",
      items: [
        {
          tag: "PPE",
          title: "PPE Sales",
          desc:
            "Certified Personal Protective Equipment for industry, mining and construction. Check out our latest quote:",
          isQuote: true,
          quoteHeader: "Att. Purchasing – Elvis Dourado | Porto Trombetas, May 19, 2026",
          imagePlaceholder: "/epis.jpg",
          location: "Porto Trombetas",
          conditions: [
            "Payment: 100% upon material receipt",
            "Taxes included",
            "Quote validity: 10 days",
            "Delivery to Porto Trombetas: air freight via Santarém, 7 to 12 days",
          ],
          contactName: "Elvis Dourado",
          contactPhone: "(93) 99176-3730",
          cta: "Request a quote",
        },
      ],
      uniforms: {
        tag: "Uniforms",
        title: "Custom Uniforms",
        subtitle: "Quality, safety and identity for every sector.",
        imagePlaceholder: "/uniformes.jpg",
        characteristics: [
          {
            title: "High Quality Fabric",
            desc: "Comfort, durability, and resistance for everyday use."
          },
          {
            title: "Full Customization",
            desc: "Embroidery or silk screen with your brand, reinforcing your company's identity."
          },
          {
            title: "Safety and Compliance",
            desc: "Meets the standards of your segment, ensuring protection and safety."
          },
          {
            title: "Standardized Team",
            desc: "More professionalism, organization, and credibility for your business."
          }
        ],
        segments: [
          "Mining",
          "Oil and Gas Industry",
          "Industries",
          "Civil Construction",
          "Logistics and Transport",
          "Services and Maintenance"
        ],
        features: [
          { title: "Resistance", desc: "High durability materials." },
          { title: "Comfort", desc: "Lightweight and breathable fabrics." },
          { title: "Premium Finish", desc: "Reinforced seams and high standard finish." },
          { title: "Colors and Models", desc: "Various color and model options." },
          { title: "Your Brand Highlighted", desc: "Strengthen your brand with custom uniforms." }
        ],
        cta: "Request a quote for uniforms"
      },
    },
    importExport: {
      overline: "Foreign Trade",
      title: "Import & Export",
      description: "International trade operations via the Oiapoque–French Guiana border: customs clearance, cross-border logistics and simplified procedures.",
      features: [
        "Cross-border trade Brazil–French Guiana",
        "Elimination of inefficient bureaucracy",
        "Reduced time and costs for the client",
        "Cutting-edge procedure technology",
        "Documentation and licensing support",
        "Strategic headquarters in Oiapoque (AP)",
      ],
      cta: "Talk to Comex",
    },

    portfolio: {
      overline: "Success Cases",
      title: "Projects that sustain industrial operations",
      subtitle: "Maintenance, sandblasting, painting and piping delivered with BID engineering.",
      items: [
        {
          title: "Heavy Industrial Maintenance",
          desc:
            "Preventive and corrective programs in mining plants with integrated shutdown schedules.",
          tag: "Maintenance",
        },
        {
          title: "Sandblasting & Surface Treatment",
          desc:
            "Metal surface preparation according to SSPC standards for maximum coating adhesion.",
          tag: "Sandblasting",
        },
        {
          title: "Anti-corrosive Industrial Painting",
          desc:
            "Epoxy and polyurethane painting systems on large structures, tanks and piping.",
          tag: "Painting",
        },
        {
          title: "Assembly & Piping",
          desc:
            "Engineering, fabrication and assembly of industrial piping with leak and NDT tests.",
          tag: "Piping",
        },
      ],
    },
    form: {
      title: "Book Technical Consulting",
      subtitle:
        "Fill out the form below. Our engineering team replies within 1 business day.",
      name: "Full name",
      company: "Company",
      role: "Role / Position",
      email: "Corporate email",
      phone: "Phone / WhatsApp",
      message: "Describe your operational challenge",
      submit: "Send request",
      whatsapp: "Talk now on WhatsApp",
      success: "Request sent! Our team will be in touch soon.",
      error: "Could not send. Please try again or use WhatsApp.",
    },
    footer: {
      slogan: "A company at the service of life.",
      description:
        "Integrated engineering for mining, heavy industry and critical operations across Brazil.",
      sections: {
        company: "Company",
        services: "Services",
        contact: "Contact",
      },
      seal: "Quality and Professionalism Seal",
      rights: "All rights reserved.",
    },
    common: {
      learnMore: "Learn more",
      close: "Close",
    },
  },
};

export const CONTACT = {
  whatsappRaw: "5596999145915",
  whatsappDisplay: "+55 (96) 99914-5915",
  whatsappSecondaryRaw: "5596999728740",
  whatsappSecondaryDisplay: "+55 (96) 99972-8740",
  email: "bidimpexp@gmail.com",
  emailSecondary: "lucio.juniorpa@gmail.com",
  emails: [
    { label: "CEO", address: "ceo@bidsolucoes.com" },
    { label: "Engenharia", address: "engenharia@bidsolucoes.com" },
    { label: "Comercial", address: "comercialsst@bidsolucoes.com" },
    { label: "EPIs", address: "episst@bidsolucoes.com" },
    { label: "Compras", address: "comprasst@bidsolucoes.com" },
  ],
  address: "Rua Presidente Kennedy, 74 — Oiapoque, AP — 68.980-000",
  cnpj: "39.486.602/0001-36",
  legalName: "BID Soluções Integradas",
  contactPerson: "ISAAC SILVA",
  contactRole: "CEO",
  contactPerson2: "Lúcio Júnior",
  contactRole2: "Coordenador de SSMA",
  domain: "bidsolucoes.com",
};
